import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import BreadCrumb from "Components/Common/BreadCrumb";
import CalenderView from "Components/Common/CalenderView";
import { Button } from "@mui/material";
import getFileExtension from "utils/getFileExtension";
import { toast } from "react-toastify";
import { usePostUploadAuditCalendarMutation } from "apis/FireSafety/FireApplicationDetail";
import Backdrop from "Components/Common/Backdrop";

const validFileFormats = ["xls", "xlsx"];

const FireSafetyAuditCalender = ({ t }) => {
  const [uploadCalendar, { isLoading: isCalendarUploading }] =
    usePostUploadAuditCalendarMutation();

  const handleUploadFile = async (selectedFile) => {
    try {
      const formData = new FormData();
      const fileExtension = getFileExtension(selectedFile.name)?.toLowerCase();
      if (!validFileFormats.includes(fileExtension)) {
        toast.error(
          "Invalid file format, Please upload file with .xsl or .xlsx extension."
        );
      } else {
        formData.append("file", selectedFile);

        await uploadCalendar(formData);
      }
    } catch (err) {}
  };

  return (
    <div className="page-content">
      <Backdrop open={isCalendarUploading} />
      <BreadCrumb title={t("Calendar")} pageTitle={t("Calendar")} />
      <div className="text-end my-2">
        <Button
          variant="contained"
          size="medium"
          className="ms-2"
          component="label"
        >
          {t("Upload")}
          <input
            style={{
              display: "none",
            }}
            accept=".xls, .xlsx"
            type="file"
            onChange={async (e) => {
              await handleUploadFile(e.target.files[0], true);
              e.target.value = null;
            }}
          />
        </Button>
      </div>
      <CalenderView isCalendarScreen />
    </div>
  );
};

FireSafetyAuditCalender.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(FireSafetyAuditCalender);
